import { enumTagState, enumXMLLoaderErr } from "../constants";
import { QXMLLoadObj } from "./QXMLLoadObj";

export class QXMLLoader {
  constructor() {
    // this.fStreamPosition = 0;
    this.fErrorCode = enumXMLLoaderErr.noErr;
    this.fLine = 0;
    this.fStream = null;
    this.fCurrentObj = null;
    this.fRootObj = null;

    this.fProcessComment = false;
    this.fLinePosition = 0;
  }

  SetErrorCode(err) {
    this.fErrorCode = err;
  }

  GetErrorCode(err) {
    return this.fErrorCode;
  }

  GetNextLine() {
    var lineString = null;
    if (this.fLine < this.fStream.StreamStringCount()) {
      var lineString = this.fStream.GetIndexString(this.fLine);
      this.fLine++;
    }

    return lineString;
  }

  IsWhiteSpace(aString) {
    var n = aString.length;

    for (var i = 0; i < n; i++) if (aString[i] != " " && aString[i] != "\t") return false;

    return true;
  }

  GetNextTag(aLine) {
    var n = aLine.length;
    if (this.fLinePosition >= n) return "";

    var nextTag = "";
    var done = false;
    var tagState = enumTagState.unknown;
    var lp = this.fLinePosition;
    while (!done) {
      var c = aLine[lp];
      switch (tagState) {
        case enumTagState.unknown:
          if (c == "<") {
            if (this.IsWhiteSpace(nextTag)) {
              tagState = enumTagState.foundOpen;
              nextTag = "<";
            } else done = true;
          } else nextTag += c;
          break;
        case enumTagState.foundOpen:
          nextTag += c;
          if (c == ">") {
            lp++;
            done = true;
          }
          break;
      }

      if (done == false) {
        lp++;
        if (lp == n) {
          if (tagState == enumTagState.foundOpen)
            this.SetErrorCode(enumXMLLoaderErr.incompleteLine);
          done = true;
        }
      }
    }
    this.fLinePosition = lp;

    return nextTag;
  }

  GetTags(aLine) {
    var tagList = new Array();
    var n = aLine.length;
    if (n == 0) return tagList;

    this.fLinePosition = 0;
    var done = false;
    while (!done) {
      var aTag = this.GetNextTag(aLine);
      if (aTag == "") done = true;
      else tagList.push(aTag);
    }

    // Optimization for reducing file size <v>aaa</v> replaced by !aaa
    if (tagList.length == 1 && tagList[0].length > 1) {
      if (tagList[0][0] == "!") {
        tagList[0] = tagList[0].substr(1);
        tagList.unshift("<v>");
        tagList.push("</v>");
      }
    }

    return tagList;
  }

  StripElementTag(aTag, openTag) {
    var strippedTag = "";
    var minLen = 3;
    if (!openTag) minLen = 4;

    var n = aTag.length;
    if (n < minLen) {
      // throw an exception here
      return "";
    }

    var endT = n - 1;
    if (aTag[endT - 1] == "/" && aTag[endT] == ">") endT--;
    var strippedTag = aTag.slice(minLen - 2, endT);
    return strippedTag;
  }

  AddNewObject(aTag) {
    var stripTag = this.StripElementTag(aTag, true);
    var params = stripTag.split(" ");

    //stripTag = params[0];
    stripTag = this.Decode(params[0]);
    if (stripTag != params[0]) {
      console.log("Decodo");
    }

    var newObj = new QXMLLoadObj();
    newObj.InitObj(stripTag, this.fCurrentObj);
    newObj.AddParams(params);

    if (this.fCurrentObj != null) this.fCurrentObj.AddChild(newObj);
    this.fCurrentObj = newObj;

    if (this.fRootObj == null) this.fRootObj = newObj;
  }

  CloseComment(aTag) {
    var index = aTag.indexOf("-->");
    if (index != -1) {
      this.fProcessComment = false;
    }
  }

  CloseObject(aTag, checkBalance) {
    if (this.fCurrentObj == null) {
      // throw an exception here
      return;
    }

    if (checkBalance) {
      var objName = this.StripElementTag(aTag, false);
      var curObjName = this.fCurrentObj.GetElementName();

      if (objName != curObjName) {
        // throw an exception here
        return;
      }
    }

    this.fCurrentObj = this.fCurrentObj.GetParent();
  }

  AddValueToCurrentObject(aTag) {
    if (this.fCurrentObj == null) {
      // throw an exception here
      return;
    }

    this.fCurrentObj.AddValue(aTag);
  }

  Decode(str) {
    var index = str.indexOf("&");
    if (index == -1) return str;

    var done = false;
    while (!done) {
      var n = str.length;
      str = str.replace("&lt;", "<");
      str = str.replace("&gt;", ">");
      str = str.replace("&amp;", "&");
      str = str.replace("&apos;", "'");
      str = str.replace("&quot;", '"');
      str = str.replace("&#39;", "'");
      str = str.replace("&#xD;", "\n");

      var n1 = str.length;
      if (n == n1) done = true;
    }

    return str;
  }

  IsEmptyTag(aTag) {
    var n = aTag.length;
    if (n >= 4) {
      var l = aTag[n - 1];
      if (l == ">") {
        var l2 = aTag[n - 2];
        if (l2 == "/") return true;
      }
    }

    return false;
  }

  ProcessTag(aTag) {
    var c1 = aTag[0];

    if (this.fProcessComment) {
      this.CloseComment(aTag);
      return;
    }

    if (c1 == "<") {
      if (aTag.length < 2) {
        console.log("Error - incomplete Tag", aTag);
        return;
      }

      var c2 = aTag[1];
      switch (c2) {
        case "!":
          if (aTag.length > 3) {
            var c3 = aTag[2];
            var c4 = aTag[3];
            if (c3 == "-" && c4 == "-") this.fProcessComment = true;
          }
          break;
        case ">":
          //console.log("Error - empty element name", aTag)
          //console.log("Tag is comment:", aTag);
          break;
        case "/":
          //console.log("Tag is object close:", aTag);
          this.CloseObject(aTag, true);
          break;
        default:
          var emptyTag = this.IsEmptyTag(aTag);
          this.AddNewObject(aTag);
          if (emptyTag) this.CloseObject(aTag, false);
          break;
      }
    } else {
      var d = this.Decode(aTag);
      this.AddValueToCurrentObject(d);
    }
  }

  ProcessLine(aLine) {
    var tags = this.GetTags(aLine);

    var n = tags.length;
    for (var i = 0; i < n; i++) this.ProcessTag(tags[i]);
  }

  LoadXML(stream) {
    this.fRootObj = null;
    this.fStream = stream;

    var done = false;
    while (!done) {
      var aLine = this.GetNextLine();
      if (aLine == null) done = true;
      else this.ProcessLine(aLine);
    }

    return this.fRootObj;
  }
}
